import React from "react";
import { useSelector } from "react-redux";
import { TranslationText } from "components/TextTranslationContainer";
import { t } from "i18next";
import { computeCodFee } from "utils/Utils";

// Tells the customer about the cash handling fee as soon as cash is chosen on a
// delivery order. Amount comes from computeCodFee (same source as the summary
// row and the order payload), so it is hidden whenever no fee is charged,
// including when the brand has switched the fee off.
const CodFeeNotice = ({ className = "" }) => {
  const { orderType } = useSelector((state) => state?.AppReducer);
  const { selectedPayment } = useSelector((state) => state?.store);
  useSelector((state) => state?.brandStorageReducer?.brandInfo?.setting?.chargeCodFee);

  const fee = computeCodFee(orderType?.serviceType, selectedPayment?.paymentType);
  if (!(fee > 0)) return null;

  return (
    <div className={`w-full text-14x text-gray-600 ${className}`}>
      <TranslationText
        text="COD fee notice"
        contentProps={{ currency: t("AED"), amount: fee.toFixed(2) }}
      />
    </div>
  );
};

export default CodFeeNotice;
